import { BrokerSignContentWrapper } from '../content-wrapper'

import { Props } from './model'

export const BrokerSignSuccess = ({ content }: Props) => {
	return BrokerSignContentWrapper({
		title: 'Спасибо!',
		children: content,
	})
}
